import { get, chain, pickBy } from "lodash"
import moment from "moment"
import { createSelector } from "reselect"
import { computeCategoryItemsSubset, computeNonZerosKeys } from "helpers/analyze"
import { getComputedFactors, getOrderedCategoryItems } from "./items"
import { getRiskHistory } from "./risk"

export function computeRiskData(items, risk) {
  const computed = chain(risk)
    .map((datum, index) => {
      const { date } = datum

      const result = chain(items)
        .map(item => ([
          item.id,
          item.fn
            ? item.fn(datum)
            : get(datum, item.field, 0),
        ]))
        .filter(([, value]) => !Number.isNaN(value))
        .fromPairs()
        .value()

      result.date = moment(date)
      result.index = index

      return result
    })
    .filter(datum => datum)
    .value()
  return computed
}

export const getData = createSelector(
  [getComputedFactors, getRiskHistory],
  computeRiskData,
)

export const getNonZerosKeys = createSelector(
  [getData],
  computeNonZerosKeys,
)

export const getFilteredData = createSelector(
  [getData, getNonZerosKeys],
  (data, keys) => data.map(item => pickBy(item, (item, key) => keys[key])),
)

export const getCategoryItemsSubset = createSelector(
  [getOrderedCategoryItems, getNonZerosKeys],
  computeCategoryItemsSubset,
)

export const getDisplayCategories = createSelector(
  [getComputedFactors, getNonZerosKeys],
  (factors, keys) => chain(factors)
    .filter(factor => keys[factor.id])
    .map(factor => [factor.category, factor.selectedView])
    .flatten()
    .compact()
    .uniq()
    .value(),
)
